import {uploadCroppedImage} from "../common/file_upload";

$(function() {
  "use strict";

  // 配信対象(会員区分)チェックを全選択
  $("#AllTrueMember").click(function () {
    $('.target-member').prop("checked", true);
  });

  // 配信対象(会員区分)チェックを全解除
  $("#AllFalseMember").click(function () {
    $('.target-member').prop("checked", false);
  });

  // 配信対象(評価区分)チェックを全選択
  $("#AllTrueEvolution").click(function () {
    $('.target-evolution').prop("checked", true);
  });

  // 配信対象(評価区分)チェックを全解除
  $("#AllFalseEvolution").click(function () {
    $('.target-evolution').prop("checked", false);
  });

  // ニュース削除を本当にするか確認
  $("#delete-form").submit(function (e) {
    if (!confirm("本当に削除しますか？")) {
      e.preventDefault();
    }
  });

  //配信済ニュースの配信日時と配信対象を変更できなくする
  if ($("#news-status").val() === "done") {
    $("#distribute_at").prop("disabled", true);
    $(".target-member").prop("disabled", true);
    $(".target-evolution").prop("disabled", true);
    $("#AllTrueMember").parent().remove();
    $("#AllTrueEvolution").parent().remove();
  }

  // トップ画像アップロード
  $('#top_image_form').on('change', function() {
    uploadCroppedImage($(this), '/company/news/upload-image', 'top_image', 16 / 9);
  });

  // フッター画像アップロード
  $('#footer_image_form').on('change', function() {
    uploadCroppedImage($(this), '/company/news/upload-image', 'footer_image', 16 / 9);
  });

  // ギャラリー画像1,2,3アップロード
  $('#news_image_form_0').on('change', function() {
    uploadCroppedImage($(this), '/company/news/upload-image', 'newsImage_0', 16 / 9);
  });
  $('#news_image_form_1').on('change', function() {
    uploadCroppedImage($(this), '/company/news/upload-image', 'newsImage_1', 16 / 9);
  });
  $('#news_image_form_2').on('change', function() {
    uploadCroppedImage($(this), '/company/news/upload-image', 'newsImage_2', 16 / 9);
  });

  // 添付画像の削除
  $('.delete-img-button').on('click', function() {
    var index = $(this).data('index');
    var dataType = $(this).data('type');

    // データに対してユニークなカラム（top_image, footer_image)の場合
    if (dataType === 'unique') {
      $(`#${index}`).attr('src', '').addClass('hidden');
      $(`#${index}_form`).val('');
      $(`#cropped_${index}`).val('');
    } else {
      $(`#eventImage_${index}`).attr('src', '').addClass('hidden');
      $(`#news_image_form_${index}`).val('');
      $(`#cropped_newsImage_${index}`).val('');
    }
    $(this).closest('.event-image-wrapper').addClass('hidden');
  });
});
